import { IController } from 'angular';
import * as _ from 'lodash';

import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';
import { IWizardFilterActionsOptions } from './../../../../../components/wizard-filter-actions/wizard-filter-actions.typings';

export class ReadinessElaCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  public filteredStudents; // modified students
  public collegeReadinessElaStudentData;
  public totalStudentsWithReadinessMismatch: number;
  public options: IWizardFilterActionsOptions;
  public patches;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.collegeReadinessElaStudentData = this.getCollegeReadinessElaStudentData();
    this.totalStudentsWithReadinessMismatch = this.WizardUtils.getCountOfStudentsToBePatched(
      this.collegeReadinessElaStudentData,
    );
    this.patches = this.WizardUtils.getRegentsExamBulkPatch(this.collegeReadinessElaStudentData, 'humanName');
    this.options = {
      columnKeys: [
        'regentsNeededForCollegeReadiness',
        'maxScoreEnglishExams',
        'collegeReadyOnElaRegentsOrSatCr',
        'regentsNeededForOnTrackDiploma',
        'regentsSchedForNextAdmin',
      ],
    };
  }

  private getCollegeReadinessElaStudentData() {
    const baseObj = { 'CC ELA': { _ids: [], studentIds: [] } };
    return _.reduce(
      this.filteredStudents,
      (studentRecRatCollection, { _id, studentId, isRegentsRecRatCollegeReadinessMismatchedEla }) => {
        if (isRegentsRecRatCollegeReadinessMismatchedEla) {
          studentRecRatCollection['CC ELA']._ids.push(_id);
          studentRecRatCollection['CC ELA'].studentIds.push(studentId);
        }
        return studentRecRatCollection;
      },
      baseObj,
    );
  }
}
